export default __webpack_public_path__ + "627c2058490fa21ec026a28079af57e1.png";